import { useContext } from 'react';
import { TailwindThemeContext } from '../../contexts/tailwindThemeContext';

const useSiteBackground = () => {
  const context = useContext(TailwindThemeContext);
  if (context === undefined) throw new Error('Invalid tailwind theme context.');

  return {
    siteBackground: context.siteBackground,
    siteBackgroundColor: context.siteBackground.color,
    siteBackgroundImage: context.siteBackground.image,
    setSiteBackground: context.setSiteBackground,
  };
};

export { useSiteBackground };
